import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, of } from 'rxjs';
import { Context } from 'src/app/controls/advanced-gridview/models/context';
import { FilterInfos } from 'src/app/controls/advanced-gridview/models/filter-infos';
import { Results } from 'src/app/controls/advanced-gridview/models/results-T';
import { SortInfos } from 'src/app/controls/advanced-gridview/models/sort-infos';
import { AdvancedService } from 'src/app/controls/advanced-gridview/services/advanced-service';
import { IRestApiConfiguration } from 'src/app/models/RestApiCaller/Interfaces/rest-api-configuration.interface';
import { RestApiConfiguration } from 'src/app/models/RestApiCaller/configuration/rest-api-configuration';
import { CrudService } from '../crud-service';
import { MemoryService } from '../memory.service';

@Injectable({
    providedIn: 'root',
})
export class RestApiConfigurationsService extends CrudService implements AdvancedService<RestApiConfiguration> {
    constructor(
        private http: HttpClient,
        public override memoryService: MemoryService
    ) {
        super(memoryService);
    }

    List(
        context: Context = null,
        filters: FilterInfos[] = null,
        generalFilters: FilterInfos[] = null,
        sortInfos: SortInfos = null,
        pageNumber = 0,
        pageSize = 100
    ): Observable<Results<RestApiConfiguration>> {
        if (pageNumber != 0) {
            return of({ value: [], resultCount: 0 } as Results<RestApiConfiguration>);
        }

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/views/${this.viewId}/rest-api-configurations`).pipe(
            map((x) => {
                var res = new Results<RestApiConfiguration>();
                res.value = RestApiConfiguration.fromArray(x as IRestApiConfiguration[]);
                res.totalCount = res.value.length;
                res.resultCount = res.value.length;

                return res;
            })
        );
    }

    Export(): Observable<Blob> {
        // Appel de la Web Api
        return this.http
            .get(this.baseUrl + `/api/organizations/${this.organizationId}/views/${this.viewId}/rest-api-configurations/export`, this.getCustomResponseTypeHttpOptions('blob'))
            .pipe(
                map((res: any) => {
                    const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    return blob;
                })
            );
    }

    update(apiconfigurationId: number, apiConfiguration: RestApiConfiguration): Observable<RestApiConfiguration> {
        // Appel de la Web Api
        return this.http.put<RestApiConfiguration>(
            this.baseUrl + `/api/organizations/${this.organizationId}/views/${this.viewId}/rest-api-configurations/${apiconfigurationId}`,
            apiConfiguration,
            this.getDefaultHttpOptions()
        );
    }

    get(apiConfigurationId: number): Observable<RestApiConfiguration> {
        // Appel de la Web Api
        return this.http.get<RestApiConfiguration>(
            this.baseUrl + `/api/organizations/${this.organizationId}/views/${this.viewId}/rest-api-configurations/${apiConfigurationId}`,
            this.getDefaultHttpOptions()
        );
    }

    add(apiConfiguration: RestApiConfiguration): Observable<RestApiConfiguration> {
        // Appel de la Web Api
        return this.http.post<RestApiConfiguration>(
            this.baseUrl + `/api/organizations/${this.organizationId}/views/${this.viewId}/rest-api-configurations`,
            apiConfiguration,
            this.getDefaultHttpOptions()
        );
    }

    delete(apiConfigurationId: number): Observable<boolean> {
        // Appel de la Web Api
        return this.http
            .delete<RestApiConfiguration>(
                this.baseUrl + `/api/organizations/${this.organizationId}/views/${this.viewId}/rest-api-configurations/${apiConfigurationId}`,
                this.getDefaultHttpOptions()
            )
            .pipe(
                map((x) => {
                    return true;
                })
            );
    }
}
